module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAAAXNSR0IArs4c6QAAATFJREFUWAnt2N0JwjAQAODGUfozgCv4pg8OoG/FGVzCFaRPriC+Oki7SuNdIRAsaJK73kUwEBrKpflyhCakKP5lngFrrSnLcocV2/OI8Der8ND0yKqqttD7jhXaVwpaBPw21ZaCFgEPw/AAdOfBk9Gk9eQBvjZxGWBmIbD1gjuYzMkYY713H5tiYFRwoEXBHGhxMBWtAqag1cCpaFVwClodHIvOAhyDzgYcip7A+ENvmuYAnRrsqF3As4e6dg7YCZ99329wR5zAdV0fx3G8uYAcn4C9wDZ+Fjn8cCbgN5cEZwYo3wo5HGXzlwjBYjKyAIdiswDHYNXBsVhVcApWDZyKVQFTsOJgKlYUzIEVA3NhxcB4CQiD4d2aK9EXKK6jxmktGevQiz9xSXBdty6O5R7gBRIHD1tKWjreAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/right.png
// module id = 922
// module chunks = 1